import { store } from "redux/rootRedux/Store";

const getListFromRedux = () => {
	const storeRedux = store.getState();
	return { ...storeRedux };
}

export default getListFromRedux;